import { inject, Pipe, PipeTransform } from '@angular/core';
import { RolesPipe, injectCan$ } from '@wilson/authorization';
import {
  RoleAction,
  RoleName,
  RolePermissionSubject,
} from '@wilson/interfaces';
import { Observable, of, switchMap } from 'rxjs';

@Pipe({
  name: 'shiftDeletionEvaluator',
  standalone: true,
})
export class ShiftDeletionEvaluatorPipe implements PipeTransform {
  protected rolesPipe = inject(RolesPipe);
  protected readonly can$ = injectCan$();

  transform(isShiftSubmittedOrAccepted: boolean): Observable<boolean> {
    return this.rolesPipe.transform([RoleName.CompanyAdmin]).pipe(
      switchMap((isCompanyAdmin) => {
        if (isShiftSubmittedOrAccepted) {
          return of(isCompanyAdmin);
        } else {
          return this.can$(RoleAction.Delete, RolePermissionSubject.Shift);
        }
      }),
    );
  }
}
